import React from 'react';

const Terms = () => {
  return (
    <div style={{ padding: 20, maxWidth: 900, margin: '0 auto' }}>
      <h1>Terms of Service</h1>
      <p>
        These are the terms of service for using PDF Blink. Use the site at your own risk. The
        tools are provided as-is for convenience and demonstration. We do not accept responsibility
        for uploaded content. By using this site you agree to comply with applicable laws and not
        upload illegal content.
      </p>
      <p>Contact: <a href="mailto:support@pdfblink.com">support@pdfblink.com</a></p>
    </div>
  );
};

export default Terms;
